import script from "./ConversationPreview.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConversationPreview.vue?vue&type=script&lang=ts&setup=true"

import "./ConversationPreview.vue?vue&type=style&index=0&id=28b09c38&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28b09c38"]])

export default __exports__